<template>
  <footer id="appFooter" class="footer" v-bind:class="{ 'full-width': !auth.isLoggedIn }">
      © {{ new Date().getFullYear() }} - Cruz Roja Argentina Filial Corrientes.
  </footer>
</template>

<script>
  export default {
    name: 'app-footer',
    data () {
      return {
        auth: this.$store.state.auth
      }
    }
  }
</script>

<style scoped>
  .full-width {
    left: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/AppFooter.vue